import { Block } from 'baseui/block';
import { Spinner } from "baseui/spinner";
import useJobStore from '../../store/jobs';
import { useGet } from '../../hooks/apiHooks';
import { JobCard } from './job';
import { Job } from '@/network/definitions/job';
import { useState } from 'react';
import { Tabs, Tab } from "baseui/tabs";
import { Input } from "baseui/input";

export const Jobs = () => {
    const {
        error,
        isLoading,
        data: {
            data: allJobs = []
        } = {},
    } = useGet<Job>('agency-api/jobs');

    const [activeKey, setActiveKey] = useState('0');
    const [searchQuery, setSearchQuery] = useState('');
    const setJobs = useJobStore(state => state.setJobs)

    useEffect(() => {
        if (allJobs) {
            setJobs(allJobs as Job[]);
        }
    }, [allJobs])

    if (error) {
        return <span>Error loading jobs!</span>
    }

    if (isLoading) {
        return <Spinner />
    }

    const filteredJobs = (jobs: Job[]) => jobs.filter((job) => 
        job?.role?.toLowerCase().includes(searchQuery.toLowerCase()) || 
        job?.id?.toString().includes(searchQuery)
    );

    const activeJobs = filteredJobs((allJobs as Job[]).filter(job => job.active));
    const inactiveJobs = filteredJobs((allJobs as Job[]).filter(job => !job.active));

    return (
        <Block> 
            <Block display="flex" justifyContent="space-between" alignItems="center"  >
                <Tabs  activeKey={activeKey} onChange={({ activeKey }) => setActiveKey(activeKey.toString())} >
                    <Tab title="Active" />
                    <Tab title="Inactive" />
                </Tabs>
                <Input
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search by role name or ID..."
                    overrides={{
                        Root: {
                            style: {
                                width: '300px',
                            },
                        },
                    }}
                />
            </Block>
            
            <Block style={{
                maxHeight: "72vh",
                overflow: "scroll",
                padding: "10px",
                overflowX: "hidden"
            }}>
                {activeKey === '0' && (
                    <Block>
                        {activeJobs.length === 0 && <span>No jobs found.</span>}
                        {activeJobs.length > 0 && activeJobs.map((job) => <JobCard pointerCursor key={job.id} job={job} />)}
                    </Block>
                )}
                {activeKey === '1' && (
                    <Block>
                        {inactiveJobs.length === 0 && <span>No jobs found.</span>}
                        {inactiveJobs.length > 0 && inactiveJobs.map((job) => <JobCard pointerCursor key={job.id} job={job} />)}
                    </Block>
                )}
            </Block>
        </Block>
    )
}
